// Native bridge for the packaged Mac app (Tauri). In the browser preview these
// return false / are unused, so the web + Mac-preview behaviour is unchanged.

export function hasNative() {
  return typeof window !== "undefined" && (!!window.__TAURI__ || !!window.__renameStudioNative);
}

function invoke(cmd, args) {
  if (window.__renameStudioNative?.[cmd]) return window.__renameStudioNative[cmd](args);
  return window.__TAURI__.core.invoke(cmd, args);
}

function makeHandle(handleId) {
  return {
    handleId,
    async move(newName) { return invoke("move_item", { handleId, newName }); },
    async exists() { return invoke("path_exists", { handleId }); },
  };
}

// Opens the native macOS folder chooser (user-selected read/write) and returns
// the recursive tree in the same shape the web importer produces.
export async function nativeChooseFolder() {
  const res = await invoke("choose_folder");
  if (!res) return null;
  const items = (res.items || []).map((it) => ({ ...it, _handle: makeHandle(it.handleId) }));
  return { dirName: res.dirName, items, truncated: !!res.truncated };
}
